// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Aerodrome } from './Aerodrome';
import { Coordinate } from './Coordinate';
import { FlightPlan } from './FlightPlan';
import { PathPointLoadClassification } from './PathPointLoadClassification';
import { Flight } from './Flight';

export class PathPoint implements IPathPoint {
    location!: Coordinate;
    altitudePath!: number | undefined;
    loadClassification!: PathPointLoadClassification | undefined;

    constructor(data?: IPathPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? Coordinate.fromJS(_data["location"]) : <any>undefined;
            this.altitudePath = _data["altitudePath"];
            this.loadClassification = _data["loadClassification"];
        }
    }

    static fromJS(data: any): PathPoint {
        data = typeof data === 'object' ? data : {};
        let result = new PathPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["altitudePath"] = this.altitudePath;
        data["loadClassification"] = this.loadClassification;
        return data;
    }
}

export interface IPathPoint {
    location: Coordinate;
    altitudePath: number | undefined;
    loadClassification: PathPointLoadClassification | undefined;
}